module.exports = __webpack_public_path__ + "static/img/logo_ktb_h_c@2x.a735cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK/logo_ktb_h_c@2x.png
// module id = LAG2
// module chunks = 69